import React from 'react';
import {styled} from '@mui/material/styles';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CopyIcon from '@mui/icons-material/ContentCopyOutlined';
import {toast} from "react-toastify";
import copy from 'copy-to-clipboard'
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import logo from "../assets/deervalley.png";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const Promo = ({name,code, guid}) => {
    const copyToClipboard = (code) =>{
        copy(code)
        toast.success(code+ ' has been copied to the clipboard', )
    }
    return (
            <StyledTableRow key={guid}>
                <StyledTableCell style={{width: '30vw'}}>{name}</StyledTableCell>
                <StyledTableCell style={{width: '20vw'}} >{code}</StyledTableCell>
                <StyledTableCell >{code !== undefined && <CopyIcon color="primary" fontSize="small" onClick={() => copyToClipboard(code)}/>}</StyledTableCell>
            </StyledTableRow>)
};


export default Promo;